import axios from 'axios';

const appliedInterceptors = {};
const tokenUrl = '/u/auth/api-token';
const loginUrl = '/u/api/login';

export function getToken(resourceKey) {
    if (window.config.resources && window.config.resources[resourceKey] && window.config.resources[resourceKey].access_token) {
        return window.config.resources[resourceKey].access_token;
    }

    return axios.get(tokenUrl, { params: { resource: resourceKey } }).then(function (response) {
        window.config.resources[resourceKey] = response.data;
    }).then(function () {
        return window.config.resources[resourceKey].access_token;
    });
}

export function checkHttpStatus(response) {
    if (response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    }
}

function extractResourceKeyFromUrl(url) {
    const link = document.createElement('a');
    link.href = url;
    const resource = link.pathname.replace(/^\/?([^\/]+).*$/, '$1');
    if (window.config.resources[resource]) {
        return resource;
    }
    return null;
}

export function applyInterceptor(resourceKey){
    // interceptor to add the bearer token as a header in the request
    axios.interceptors.request.use(function (cfg) {
        const resource = extractResourceKeyFromUrl(cfg.url);
        if ( resource && window.config.resources[resource] && window.config.resources[resource].access_token ) {
            cfg.headers['Authorization'] = 'Bearer ' + window.config.resources[resource].access_token;
        }
        return cfg;
    }, function (error) {
        return Promise.reject(error);
    });

    // interceptor to handle 401 response we will request a new token and then try the request again
    // this basically allows us to not have to worry about refreshing the token every 2 hours, but instead will
    // refresh whenever it's needed
    axios.interceptors.response.use(undefined, (error) => {
        if (error.response.status === 401 && error.config && error.config.url !== loginUrl && !error.config.__isTokenRefreshed) {
            console.log('token request failed with auth error. gonna retry');
            error.config.__isTokenRefreshed = true;
            return new Promise((resolve, reject) => {
                refreshToken(resourceKey)
                    .then(() => {
                        axios(error.config).then(resolve).catch(reject);
                    })
                    .catch(() => {
                        reject(error);
                    });
            });
        }
        return Promise.reject(error);
    })
}

export function refreshToken(resourceKey) {
    if (!appliedInterceptors[resourceKey]) {
        applyInterceptor(resourceKey);
        appliedInterceptors[resourceKey] = true;
    }

    //Prevent loop when unauthorized
    if (!window.config.resources[resourceKey] || (window.config.resources[resourceKey] && window.config.resources[resourceKey].access_token != 'Unauthorized')) {
        //Request updated token
        return axios.get(tokenUrl, { params: { resource: resourceKey } }).then(function(response){
            //update the global config for this resource (access_token and expires_in)
            window.config.resources[resourceKey] = response.data;
        });
    }

    return Promise.reject();
}
